import { Component, Input } from '@angular/core';

import { InlineNoteEditorType } from './inline-note-editor-type';

@Component({
  selector: 'rl-inline-note',
  templateUrl: './inline-note.component.html',
})
export class InlineNoteComponent {
  @Input() noteType: InlineNoteEditorType;
  @Input() note: string | null;

  InlineNoteEditorType = InlineNoteEditorType;
}
